import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFixedAsideElementMobileToggle',
  props: {
    active: { type: Boolean },
    icon: { default: 'messages-question' },
    lable: { default: 'Zu den FAQ' },
    link: {},
    linkTarget: {},
    color: {},
    background: {},
    content: {}
  },
  setup(__props: any) {

const props = __props;

const itemIcon = computed(() => (props.active ? `fa-regular fa-${props.icon}` : `fa-light fa-${props.icon}`));

return (_ctx: any,_cache: any) => {
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: "base-fixed-aside__item-mobile",
    style: _normalizeStyle({
        background: _ctx.background,
        color: _ctx.color,
      })
  }, [
    _createVNode(_component_FaIcon, { icon: itemIcon.value }, null, 8, ["icon"]),
    (_ctx.link)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 0,
          to: _ctx.link,
          target: _ctx.linkTarget
        }, null, 8, ["to", "target"]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})